import type { ReactNode } from 'react';
import { Typography } from '@/ui';
import { Compass } from '@/features/sky';
import styles from './SiteFooter.module.css';

export interface SiteFooterLink {
  label: string;
  href: string;
}

export interface SiteFooterProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  links?: SiteFooterLink[];
  reveal?: 'scroll' | 'always';
  compass?: boolean;
  className?: string;
  children?: ReactNode;
}

const defaultLinks: SiteFooterLink[] = [
  { label: 'Email', href: 'mailto:email@ondrejbarta.com' },
  { label: 'GitHub', href: 'https://github.com/bartaxyz' },
  { label: 'CV', href: '/ondrej-barta-cv.pdf' },
];

export const SiteFooter = ({
  title = 'Ondřej Bárta',
  subtitle,
  links = defaultLinks,
  reveal = 'scroll',
  compass = false,
  className,
  children,
}: SiteFooterProps) => (
  <footer
    className={[styles.footer, reveal === 'scroll' && styles.arrival, className]
      .filter(Boolean)
      .join(' ')}
  >
    {children ?? (
      <>
        <p className={styles.title}>{title}</p>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {links.length > 0 && (
          <nav className={styles.links} aria-label="Footer links">
            {links.map(({ label, href }) => (
              <Typography.Link key={href} href={href}>
                {label}
              </Typography.Link>
            ))}
          </nav>
        )}
      </>
    )}
    {compass && (
      <div className={styles.compass}>
        <Compass />
      </div>
    )}
  </footer>
);
